/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IImplant } from 'app/shared/model/implant.model';
import { IImplantOrder } from 'app/shared/model/implant-order.model';

export interface IImplantOrderItem {
  id?: string;
  remarks?: string | null;
  quantity?: number;
  active?: boolean;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  cursor?: number;
  implant?: IImplant;
  order?: IImplantOrder;
}

export const defaultValue: Readonly<IImplantOrderItem> = {
  active: false,
};
